module.exports = __webpack_public_path__ + "static/media/progress_muenzen.34db9557.svg";